import { ShipperDTO } from '../../../Domain/DTO/ShipperDTO';
import { ListIntOptionDTO } from '../../../Domain/DTO/ListIntOptionDTO';
import { ShipperTableDTO } from '../../../Domain/DTO/ShipperTableDTO';

export class ShipperUserHelperProps{
    AllRoles: Array<ListIntOptionDTO>
    AllShippers: Array<ShipperTableDTO>
}

export const InitialShipperUserHelperProps: ShipperUserHelperProps = <ShipperUserHelperProps>{ AllRoles: [], AllShippers: []};